import { useMutation } from '@tanstack/react-query';
import { SuggestRecommendationNowParams, SuggestRecommendationNowRes } from '../api/openapi';
import { schedulerApi } from '../api';
import dayjs from 'dayjs';

interface UseSuggestRecNowParams {
  chatId: string;
  sessionId?: string;
  userMessage: string;
  userId: string;
  metricId: string;
  signal?: AbortSignal;
}

export const useSuggestRecNow = () => {
  const suggestRecNowMutation = useMutation({
    mutationFn: async ({
      chatId,
      sessionId,
      userMessage,
      userId,
      metricId,
      signal,
    }: UseSuggestRecNowParams): Promise<SuggestRecommendationNowRes> => {
      const params: SuggestRecommendationNowParams = {
        chatId,
        sessionId,
        userMessage,
        metricId,
        currentTime: dayjs().toISOString(),
        userId,
      };

      const response = await schedulerApi.suggestRecommendationNow(params, { signal });
      return response.data;
    },
  });

  return {
    suggestRecNow: suggestRecNowMutation.mutateAsync,
    ...suggestRecNowMutation,
  };
};
